import { render, staticRenderFns } from "./SchemaRichTxtConfig.vue?vue&type=template&id=07e3be60"
import script from "./SchemaRichTxtConfig.vue?vue&type=script&lang=js"
export * from "./SchemaRichTxtConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports